export const pageLinks = (linkSelector = '.sp-pagelinks a[href^="#"]') => {
    const links = document.querySelectorAll(linkSelector);

    links.forEach(function (link) {
        link.addEventListener('click', function (e) {
            if (
                location.pathname.replace(/^\//, '') ==
                    this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                const target = document.getElementById(this.hash);

                if (target.length) {
                    e.preventDefault();
                    target.scrollIntoView(true);
                }
            }
        });
    });
};
